import type { Config } from './tour'

export const CFCBasicSetupConfig: Config = {
  steps: [
    // Intro
    {
      title: 'cfc.tutorial.template1.step1.title',
      text: 'cfc.tutorial.template1.step1.text',
      showNextButton: true,
    },
    // Add a new module
    {
      title: 'cfc.tutorial.template1.step2.title',
      text: 'cfc.tutorial.template1.step2.text',
      attachElement: '[data-test=module-hangup]',
      nextOnClickElements: ['[data-test=module-hangup]'],
      attachPosition: 'top',
    },
    // Select playback module
    {
      title: 'cfc.tutorial.template1.step3.title',
      text: 'cfc.tutorial.template1.step3.text',
      attachElement: '[data-option-module-type=playback]',
      attachPosition: 'top',
      nextOnClickElements: ['[data-option-module-type=playback]'],
    },
    // Edit playback module
    {
      title: 'cfc.tutorial.template1.step4.title',
      text: 'cfc.tutorial.template1.step4.text',
      delay: 500,
      attachElement:
        '[data-module-type=playback] [data-test=module-edit-button]',
      attachPosition: 'top',
      nextOnClickElements: [
        '[data-module-type=playback] [data-test=module-edit-button]',
      ],
    },
    // Go to select audio file
    {
      title: 'cfc.tutorial.template1.step5.title',
      text: 'cfc.tutorial.template1.step5.text',
      delay: 600,
      attachElement: '[data-test=edit-module] [data-input-name=audioFileId]',
      attachPosition: 'bottom',
      nextOnClickElements: [
        '[data-test=edit-module] [data-input-name=audioFileId] [role=combobox]',
      ],
    },
    // Select easybell waiting musik
    {
      title: 'cfc.tutorial.template1.step7.title',
      text: 'cfc.tutorial.template1.step7.text',
      attachElement: '.eb-select__dropdown-wrapper__dropdown',
      padding: 0,
      attachPosition: 'top',
      nextOnClickElements: ['.eb-select__dropdown-wrapper__dropdown'],
    },
    // Close the edit modal
    {
      title: 'cfc.tutorial.template1.step8.title',
      text: 'cfc.tutorial.template1.step8.text',
      attachElement: '[data-test=module-edit-close-button]',
      attachPosition: 'top',
      nextOnClickElements: ['[data-test=module-edit-close-button]'],
    },
    // Save changes
    {
      title: 'cfc.tutorial.template1.step9.title',
      text: 'cfc.tutorial.template1.step9.text',
      padding: 0,
      attachElement: '[data-test=cfc-dropdown-trigger-left]',
      attachPosition: 'bottom',
      nextOnClickElements: ['[data-test=cfc-dropdown-trigger-left]'],
    },
    // Finished message
    {
      title: 'cfc.tutorial.template1.step10.title',
      text: 'cfc.tutorial.template1.step10.text',
      showFinishButton: true,
      attachElement: '.eb-modal__card',
    },
  ],
}
